module.exports = "<div class=\"bar-wrapper\">\n</div>"